import { generateUuid } from '../utils/string';

export default class BaseModel {
  constructor(type, id) {
    this.id = id || generateUuid();
    this.type = type;
  }

  deSerialize(data = {}) {
    this.id = data.id;
  }

  serialize() {
    return {
      id: this.id,
      type: this.type,
    };
  }

  getType() {
    return this.type;
  }
  getID() {
    return this.id;
  }
}
